import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { HttpService, ModelBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { ProductRelatedEInvoiceItemModel } from '@skylab-shared/dataModel';
import { RecursiveDiff } from '@skylab-shared/types';
import { fillPlaceholders } from '@skylab-shared/utils';

export type ProductGetAssociatedEInvoiceSymbol = RecursiveDiff<ProductRelatedEInvoiceItemModel, ModelBase>;

export class ProductGetAssociatedEInvoiceSymbolsQuery extends Query<ProductGetAssociatedEInvoiceSymbol[]> {
    constructor(readonly params: {externalId: string}) {
        super()
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductGetAssociatedEInvoiceSymbolsQuery)
export class ProductGetAssociatedEInvoiceSymbolsQueryHandler implements QueryHandler<ProductGetAssociatedEInvoiceSymbolsQuery, ProductGetAssociatedEInvoiceSymbol[]> {
    #Url = TaggedUrl.join('products/:externalId/associatedEInvoiceSymbols', [Tags.Api, Tags.OmitMessage]);
    #http =  inject(Http) as HttpService;

    async handleAsync(query: ProductGetAssociatedEInvoiceSymbolsQuery): Promise<ProductGetAssociatedEInvoiceSymbol[]> {
        try {
            const url = fillPlaceholders(this.#Url, { externalId: query.params.externalId });
            const result = await this.#http.get(url);
            return result.data;
        } catch (err) {
            return [];
        }
    }
}